const state = () => ({
  email: ''
});

const getters = {
  email(state) {
    return state.email;
  }
};

const mutations = {
  setEmail(state, payload) {
    state.email = payload;
  },
  resetStore(state) {
    state.email = '';
  }
};

export const login = {
  state,
  getters,
  mutations,
  namespaced: true
};
